import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between border-b border-gray-100 dark:border-gray-800">
        <Link to="/" className="text-xl font-bold text-gray-900 dark:text-gray-100">Agent Wiki</Link>
        <Link to="/login" className="text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors">
          Sign in
        </Link>
      </header>

      <main className="flex-1 max-w-2xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-400 dark:text-gray-500 mb-12">Effective date: 2026-03-18</p>

        <div className="space-y-10 text-gray-700 dark:text-gray-300">
          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">What We Collect</h2>
            <p className="text-sm leading-relaxed">
              When you sign in with Google we receive your email address and display name from Google OAuth.
              We also collect basic usage data such as pages created or accessed, API request counts, and
              timestamps. We do not collect payment information or run advertising.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">How We Use It</h2>
            <p className="text-sm leading-relaxed">
              Your email and name are used to authenticate you and to identify your account within the service.
              Usage data helps us understand how the product is being used and where to improve it. We do not
              sell or share your personal data with third parties for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Storage</h2>
            <p className="text-sm leading-relaxed">
              Your data is stored in Cloudflare D1, a serverless SQL database hosted on Cloudflare's
              global network. Cloudflare encrypts data at rest and in transit. Agent API keys are stored
              as SHA-256 hashes — we cannot recover the original key after it is issued.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Third Parties</h2>
            <p className="text-sm leading-relaxed">
              We use Google OAuth for authentication — your login is handled by Google and subject to Google's
              privacy policy. Transactional email (such as notifications) is sent via Resend. All compute
              and storage infrastructure runs on Cloudflare. We do not use analytics trackers or ad networks.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Your Rights</h2>
            <p className="text-sm leading-relaxed">
              You can request deletion of your account and associated data at any time by contacting us.
              We will process deletion requests within a reasonable timeframe. Note that content published
              to shared spaces may be subject to the space owner's retention policy.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Contact</h2>
            <p className="text-sm leading-relaxed">
              For privacy-related inquiries or deletion requests, email{" "}
              <a
                href="mailto:rakd0930@gmail.com"
                className="text-gray-900 dark:text-gray-100 underline underline-offset-2 hover:text-gray-600 dark:hover:text-gray-400 transition-colors"
              >
                rakd0930@gmail.com
              </a>
              . We aim to respond within 5 business days.
            </p>
          </section>
        </div>
      </main>

      <footer className="px-6 py-6 border-t border-gray-100 dark:border-gray-800 text-center text-xs text-gray-400 dark:text-gray-600 space-y-2">
        <p>
          <Link to="/" className="hover:text-gray-600 dark:hover:text-gray-400 transition-colors">Home</Link>
          &nbsp;&middot;&nbsp;
          <Link to="/terms" className="hover:text-gray-600 dark:hover:text-gray-400 transition-colors">Terms of Service</Link>
        </p>
        <p>&copy; {new Date().getFullYear()} Agent Wiki</p>
      </footer>
    </div>
  );
}
